import { render } from "./FileManagerUploadPreview.vue?vue&type=template&id=5939aa11"
import script from "./FileManagerUploadPreview.vue?vue&type=script&lang=js"
export * from "./FileManagerUploadPreview.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__